import { render, staticRenderFns } from "./ListAllHomeworkStudent.vue?vue&type=template&id=456eca72&scoped=true"
import script from "./ListAllHomeworkStudent.vue?vue&type=script&lang=js"
export * from "./ListAllHomeworkStudent.vue?vue&type=script&lang=js"
import style0 from "./ListAllHomeworkStudent.vue?vue&type=style&index=0&id=456eca72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456eca72",
  null
  
)

export default component.exports